export default "__VITE_ASSET__Dvdkuj2P__"